(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 1100px)');
  let teardown = () => {};
  function start() {
    teardown();
    const hero = document.querySelector('.br-team[data-br-scroll-effects="true"]');
    const stories = Array.from(document.querySelectorAll('.br-story[id]'));
    if (!hero || !stories.length || reduce.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    const animations = new Set();
    const visible = new Set();
    const revealed = new WeakSet();
    const sceneMedia = new Map(stories.map(el => [el, el.querySelector('.br-scene img')]));
    const entry=hero.closest('[data-br-brand-entry]');
    const entryIntro=entry?.querySelector('.br-brand-entry__intro');
    const entryMark=entry?.querySelector('.br-brand-entry__mark');
    const entryTarget=hero.querySelector('.br-team__logo');
    entry?.classList.add('is-animated');
    const nav = document.createElement('nav');
    nav.className = 'br-chapters';
    nav.setAttribute('aria-label', hero.dataset.chaptersLabel || 'Einkaufswelten');
    const links = stories.map((story, i) => {
      const a = document.createElement('a');
      const number = document.createElement('span');
      const label = document.createElement('span');
      const heading = story.querySelector('h2')?.textContent.trim() || '';
      a.href = '#' + story.id;
      a.className = 'br-chapters__link';
      a.setAttribute('aria-label', heading);
      a.dataset.world = story.dataset.world;
      number.textContent = String(i + 1).padStart(2, '0');
      number.setAttribute('aria-hidden', 'true');
      label.className = 'br-chapters__label';
      label.textContent = heading;
      label.setAttribute('aria-hidden', 'true');
      a.append(number, label);
      nav.append(a);
      return a;
    });
    document.body.append(nav);
    document.documentElement.classList.add('br-cinematic');
    stories.forEach(el => el.setAttribute('data-br-scene', 'true'));
    const clamp = (v, min = 0, max = 1) => Math.min(max, Math.max(min, v));
    function animate(el, frames, options) {
      if (!el.animate) return;
      const a = el.animate(frames, options);
      animations.add(a);
      a.finished.then(() => animations.delete(a)).catch(() => animations.delete(a));
    }
    const reveal = new IntersectionObserver(entries => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting || revealed.has(target)) return;
        revealed.add(target);
        reveal.unobserve(target);
        if (target.matches('.br-story__content')) {
          const world = target.closest('.br-story')?.dataset.world;
          const precise = world === 'range' || world === 'tactical';
          const distance = desktop.matches ? (precise ? 18 : 30) : 9;
          Array.from(target.children).forEach((el, i) => animate(el,
            [{ opacity: .18, transform: precise && desktop.matches ? `translateX(${-distance}px)` : `translateY(${distance}px)` }, { opacity: 1, transform: 'translate(0,0)' }],
            { duration: precise ? 620 : 900, delay: i * (desktop.matches ? 65 : 35), easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' }));
        } else {
          const cards = Array.from(target.children);
          cards.forEach((el, i) => animate(el,
            [{ opacity: .3, transform: `translateY(${desktop.matches ? 38 : 12}px)` }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 850, delay: (i % (desktop.matches ? 4 : 2)) * 90, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' }));
        }
      });
    }, { threshold: .12 });
    document.querySelectorAll('.br-story__content.br-reveal,.br-grid--worlds').forEach(el => reveal.observe(el));
    let frame = 0;
    function paint() {
      frame = 0;
      const height = innerHeight;
      let active = -1;
      let closest = Infinity;
      const updates = [];
      if(entryMark&&entryTarget){
        const box=entry.getBoundingClientRect();
        const introHeight=entryIntro.offsetHeight;
        const p=clamp(-box.top/Math.max(1,introHeight));
        const ease=p*p*(3-2*p);
        const width=entryMark.offsetWidth;
        const targetImage=entryTarget.querySelector('img');
        const markImage=entryMark.querySelector('img');
        const scale=targetImage.clientWidth/markImage.clientWidth;
        const x0=(entry.clientWidth-width)/2;
        const y0=Math.max(34,(introHeight-entryMark.offsetHeight)/2-55);
        const x1=entryTarget.offsetLeft+targetImage.offsetLeft-markImage.offsetLeft*scale;
        const y1=introHeight+entryTarget.offsetTop+targetImage.offsetTop-markImage.offsetTop*scale;
        updates.push(()=>{
          entryMark.style.transform=`translate3d(${x0+(x1-x0)*ease}px,${y0+(y1-y0)*ease}px,0) scale(${1+(scale-1)*ease})`;
          entryMark.style.opacity=p>.995?'0':'1';
          entryTarget.style.opacity=p>.995?'1':'0';
          entry.style.setProperty('--br-intro-progress',p.toFixed(3));
        });
      }
      visible.forEach(el => {
        const rect = el.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const travel = clamp((height / 2 - center) / ((height + rect.height) / 2), -1, 1);
        const progress = clamp((height * .65 - rect.top) / rect.height);
        if (el === hero) {
          updates.push(() => {
            const progress=clamp(-rect.top/(rect.height*.8));
            hero.style.setProperty('--br-entry',progress.toFixed(3));
            const logo=hero.querySelector('.br-team__logo');
            if(logo&&!entry){const travel=Math.min(Math.max(0,-rect.top),desktop.matches?rect.height-120:260);logo.style.transform=`translate3d(0,${travel}px,0) scale(${1-progress*.3})`;logo.style.opacity=String(1-clamp((progress-.68)/.32));}
            const photo = hero.querySelector('.br-team__photo img');
            if (photo) photo.style.transform = desktop.matches ? `translate3d(0,${clamp(-rect.top / rect.height) * 26}px,0) scale(${1 + clamp(-rect.top / rect.height) * .04})` : '';
          });
          return;
        }
        const i = stories.indexOf(el);
        const distance = Math.abs(center - height / 2);
        if (rect.top < height * .65 && rect.bottom > height * .35 && distance < closest) { closest = distance; active = i; }
        const world = el.dataset.world;
        const precise = world === 'range' || world === 'tactical';
        const depth = world === 'outdoor' || world === 'hunting' ? 28 : world === 'airsoft' ? 22 : 14;
        const media = sceneMedia.get(el);
        updates.push(() => {
          el.style.setProperty('--br-scene-progress', progress.toFixed(3));
          if (media) media.style.transform = desktop.matches ? `translate3d(${precise ? travel * 14 : 0}px,${precise ? 0 : travel * depth}px,0) scale(1.075)` : '';
        });
      });
      updates.forEach(fn => fn());
      nav.classList.toggle('is-visible', active >= 0 && desktop.matches);
      links.forEach((link, i) => { if (i === active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
    }
    const schedule = () => { if (!frame && !document.hidden) frame = requestAnimationFrame(paint); };
    const watch = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
      schedule();
    }, { rootMargin: '15% 0px' });
    [hero, ...stories].forEach(el => watch.observe(el));
    const resize = () => {
      if (!desktop.matches) { sceneMedia.forEach(media => { if (media) media.style.transform = ''; }); const photo = hero.querySelector('.br-team__photo img'); if (photo) photo.style.transform = ''; }
      schedule();
    };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', resize, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    schedule();
    teardown = () => {
      cancelAnimationFrame(frame);
      removeEventListener('scroll', schedule);
      removeEventListener('resize', resize);
      document.removeEventListener('visibilitychange', schedule);
      watch.disconnect(); reveal.disconnect();
      animations.forEach(a => a.cancel());
      nav.remove();
      stories.forEach(el => { el.removeAttribute('data-br-scene'); el.style.removeProperty('--br-scene-progress'); });
      sceneMedia.forEach(media => { if (media) media.style.transform = ''; });
      const photo = hero.querySelector('.br-team__photo img');
      if (photo) photo.style.transform = '';
      const logo=hero.querySelector('.br-team__logo');
      if(logo){logo.style.transform='';logo.style.opacity='';}
      hero.style.removeProperty('--br-entry');
      entry?.classList.remove('is-animated');
      if(entryMark){entryMark.style.transform='';entryMark.style.opacity='';}
      document.documentElement.classList.remove('br-cinematic');
      teardown = () => {};
    };
  }
  start();
  reduce.addEventListener('change', start);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', start);
})();
